import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../helpers/axiosInstance";
import { toast } from "react-toastify";

const initialState = {
    inboxData: [],
    pagination: null,
    loading: false,
    error: null,
};

export const getRuleEngineManagementInboxData = createAsyncThunk(
    "rule-engine-management/inbox",
    async ({ user, pagination, search = {} }, thunkAPI) => {
        try {
            const { url, endpoint } = user?.routesConfig;

            const isMaker = window?.location?.pathname?.includes('maker');
            const isChecker = window?.location?.pathname?.includes('checker');

            let apiURL;

            if (isMaker) {
                const base = url?.acsbackofficemanagement;
                const endpointpath = endpoint?.acsbackofficemanagement?.getPendingRuleListForMaker;
                apiURL = base + endpointpath + `${pagination.pageSize}/${pagination.currentPage}`;

            } else if (isChecker) {
                const base = url?.acsbackofficemanagement;
                const endpointpath = endpoint?.acsbackofficemanagement?.getCheckerPendingRuleList;
                apiURL = base + endpointpath + `${pagination.pageSize}/${pagination.currentPage}`;
            } else {
                return thunkAPI.rejectWithValue({ skip: true });
            }

            const response = await axiosInstance.post(apiURL, search);

            return response?.data;
        } catch (error) {
            toast.error(error.response.data.message);
            throw error.response;
        }
    }
);

export const postAddedRulesReview = createAsyncThunk(
    "rule-engine-management/inbox/added-rules-review",
    async ({ user, body }, thunkAPI) => {
        try {
            const { url, endpoint } = user?.routesConfig;

            const isMaker = window?.location?.pathname?.includes('maker');
            const isChecker = window?.location?.pathname?.includes('checker');

            let apiURL;

            if (isMaker) {
                const base = url?.acsbackofficemanagement;
                const endpointpath = endpoint?.acsbackofficemanagement?.updaterulemakerreviewtasks;
                apiURL = base + endpointpath;

            } else if (isChecker) {
                const base = url?.acsbackofficemanagement;
                const endpointpath = endpoint?.acsbackofficemanagement?.addRuleCheckerReviewTasks;
                apiURL = base + endpointpath;
            } else {
                return thunkAPI.rejectWithValue({ skip: true });
            }

            const response = await axiosInstance.post(apiURL, body);
            toast.success(body.isaccepted ? 'Request accepted and send successfully' : 'Request rejected and send successfully');
            return { ...response?.data, status: response.status };
        } catch (error) {
            toast.error(error.response.data.message);
            throw error.response;
        }
    }
);

export const postUpdatedRulesReview = createAsyncThunk(
    "rule-engine-management/inbox/updated-rules-review",
    async ({ user, body }, thunkAPI) => {
        try {
            const { url, endpoint } = user?.routesConfig;

            const isMaker = window?.location?.pathname?.includes('maker');
            const isChecker = window?.location?.pathname?.includes('checker');

            let apiURL;

            if (isMaker) {
                const base = url?.acsbackofficemanagement;
                const endpointpath = endpoint?.acsbackofficemanagement?.updaterulemakerreviewtasks;
                apiURL = base + endpointpath;

            } else if (isChecker) {
                const base = url?.acsbackofficemanagement;
                const endpointpath = endpoint?.acsbackofficemanagement?.addRuleCheckerReviewTasks;
                apiURL = base + endpointpath;
            } else {
                return thunkAPI.rejectWithValue({ skip: true });
            }

            const response = await axiosInstance.post(apiURL, body);
            toast.success(body.isaccepted ? 'Request accepted and send successfully' : 'Request rejected and send successfully');
            return { ...response?.data, status: response.status };
        } catch (error) {
            toast.error(error.response.data.message);
            throw error.response;
        }
    }
);

const ruleEngineManagementInboxSlice = createSlice({
    name: "rule-engine-management-inbox",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // GET ALL RULES INBOX DATA
            .addCase(getRuleEngineManagementInboxData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getRuleEngineManagementInboxData.fulfilled, (state, action) => {
                const { data, currentPage, pageSize, totalItem, totalPages } = action?.payload;
                state.loading = false;
                state.inboxData = data || [];
                state.pagination = { currentPage, pageSize, totalItem, totalPages }
            })
            .addCase(getRuleEngineManagementInboxData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            // ADD RULES REVIEW
            .addCase(postAddedRulesReview.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(postAddedRulesReview.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(postAddedRulesReview.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            // UPDATE RULES REVIEW
            .addCase(postUpdatedRulesReview.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(postUpdatedRulesReview.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(postUpdatedRulesReview.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
    },
});

export default ruleEngineManagementInboxSlice.reducer;